import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import loyaltyCardsReducer from './loyaltySlices/loyaltyCardsSlice';
import loyaltyRewardsReducer from './loyaltySlices/loyaltyRewardsSlice';
import loyaltyAssignReducer from './loyaltySlices/loyaltyAssignSlice';
import loyaltyPrintReducer from './loyaltySlices/loyaltyPrintSlice';
import loyaltyRedemptionReducer from './loyaltySlices/loyaltyRedemptionSlice';
import loyaltyReportsReducer from './loyaltySlices/loyaltyReportsSlice';
import rewardLedgerReducer from './loyaltySlices/rewardLedgerSlice';
import membershipReducer from './loyaltySlices/membershipSlice';
import cityServiceReducer from './citySlices/cityServiceSlice';
import storeCategoriesReducer from './storeCategoriesSlice';
import storeDiscoverReducer from './storeSlices/storeDiscoverSlice';
import storeNearbyReducer from './storeNearbySlice';
import storeReducer from './storeSlices/storeSlice';
import storeDetailReducer from './storeSlices/storeDetailSlice';
import walletReducer from './walletSlice';
import paymentReducer from "./paymentSlices/paymentSlice";
import paymentConfirmationReducer from "./paymentSlices/paymentConfirmationSlice";
import myVouchersReducer from './voucherSlices/myVouchersSlice';
import membershipInviteReducer from './loyaltySlices/membershipInviteSlice';
import rewardLedgerActionReducer from './ledgerSlices/rewardLedgerActionSlice';
import storeLedgerReducer from './storeSlices/storeLedgerSlice';
import storeVoucherReducer from './voucherSlices/storeVoucherSlice';
import storeBillReducer from './storeSlices/storeBillSlice';
import membersReportReducer from './reportSlices/membersReportSlice';
import performanceReportReducer from './reportSlices/performanceReportSlice';
import storeQrReducer from './storeSlices/storeQrSlice';
import storeStatusReducer from './storeSlices/storeStatusSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        loyaltyCards: loyaltyCardsReducer,
        loyaltyRewards: loyaltyRewardsReducer,
        loyaltyAssign: loyaltyAssignReducer,
        loyaltyPrint: loyaltyPrintReducer,
        loyaltyRedemption: loyaltyRedemptionReducer,
        loyaltyReports: loyaltyReportsReducer,
        rewardLedger: rewardLedgerReducer,
        membership: membershipReducer,
        cityService: cityServiceReducer,
        storeCategories: storeCategoriesReducer,
        storeDiscover: storeDiscoverReducer,
        storeNearby: storeNearbyReducer,
        store: storeReducer,
        storeDetail: storeDetailReducer,
        wallet: walletReducer,
        payment: paymentReducer,
        paymentConfirmation: paymentConfirmationReducer,
        myVouchers: myVouchersReducer,
        membershipInvite: membershipInviteReducer,
        rewardLedgerAction: rewardLedgerActionReducer,
        storeLedger: storeLedgerReducer,
        storeVoucher: storeVoucherReducer,
        storeBill: storeBillReducer,
        membersReport: membersReportReducer,
        performanceReport: performanceReportReducer,
        storeQr: storeQrReducer,
        storeStatus: storeStatusReducer,
        // add more slices here as you migrate other modules to redux
    },
});